// extracted by mini-css-extract-plugin
module.exports = {"segmented-controls":"switcher_segmented-controls__3Al5H"};